import { Flex, Skeleton } from '@backstage/ui';

export const KpcProgress = () => (
  <Flex align="center" justify="center" style={{ padding: '48px 0' }}>
    <Skeleton width={48} height={48} rounded />
  </Flex>
);
